import type { DocumentPanelTarget } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Signals/documentPanelSignal';

/** Two targets open the same panel: a field is identified by its key alone (another occurrence of it is
 * still the same panel); every other target by the whole of its primitives. */
const isSamePanelTarget = (left: DocumentPanelTarget | null, right: DocumentPanelTarget): boolean => {
	if (left === null || left.type !== right.type) {
		return false;
	}

	if (left.type === 'field' && right.type === 'field') {
		return left.fieldKey === right.fieldKey;
	}

	return JSON.stringify(left) === JSON.stringify(right);
};

export default isSamePanelTarget;
